// Variante compacte des tableaux TanStack : lignes denses, en-têtes discrets et
// collants. Née dans la comptabilité (Rapprochement, Remises, Grand livre,
// Stock), désormais partagée avec l'utilisation des subventions — ces écrans se
// lisent côte à côte, ils doivent rester alignés visuellement.
//
// S'utilise avec `getRowClassName={() => COMPACT_TABLE_ROW_CLASSNAME}` : le
// classname porte la densité, la classe de ligne porte la taille du texte.
export const COMPACT_TABLE_CLASSNAME = [
  "rounded-xl border border-slate-200 shadow-sm overflow-x-hidden",
  "[&_table]:divide-y-0",
  "[&_table]:!w-full [&_table]:!min-w-0",
  "[&_thead]:bg-slate-50",
  "[&_thead_th]:sticky [&_thead_th]:top-0 [&_thead_th]:z-10",
  "[&_thead_th]:!px-2 [&_thead_th]:!py-1.5 [&_thead_th]:!min-h-9",
  "[&_thead_th]:border-b [&_thead_th]:border-slate-200",
  "[&_thead_th]:text-[10px] [&_thead_th]:font-semibold [&_thead_th]:tracking-wide [&_thead_th]:text-slate-600",
  "[&_tbody_tr]:border-b [&_tbody_tr]:border-slate-100",
  "[&_tbody_tr:hover]:bg-slate-50/70",
  "[&_tbody_td]:!px-2 [&_tbody_td]:!py-1.5",
  "[&_tbody_td]:text-slate-800",
].join(" ");

export const COMPACT_TABLE_ROW_CLASSNAME = "text-[12px] leading-tight";
